import EditEmail from "./EditEmailPage";
import EditCustomizations from "./EditCustomizationsPage";
import EditMeta from "./EditCustomizationsPage";
import EditPostPurchaseContent from "./EditPostPurchaseContent";
import EditPage from "./EditPage";
import Main from "./Main";

export default {
  EditEmail,
  EditPage,
  EditCustomizations,
  EditMeta,
  EditPostPurchaseContent,
  Main
};
